import { render, staticRenderFns } from "./EditUserType.vue?vue&type=template&id=b7299252&scoped=true"
import script from "./EditUserType.vue?vue&type=script&lang=js"
export * from "./EditUserType.vue?vue&type=script&lang=js"
import style0 from "./EditUserType.vue?vue&type=style&index=0&id=b7299252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7299252",
  null
  
)

export default component.exports